import { lazy, Suspense, useEffect } from 'react';
import { CenteredCircularProgress } from '../../common/CenteredCircularProgress';
import { GetStartedVariant, useGetStartedVariant } from './useGetStartedVariant';

const variantToPage = {
  [GetStartedVariant.Assessments]: lazy(() => import('../assessments/AssessmentsPage')),
  [GetStartedVariant.HomeFree]: lazy(() =>
    import('./user-homepage/UserHomepage').then((m) => ({ default: m.UserHomepage })),
  ),
  [GetStartedVariant.HomeTrial]: lazy(() =>
    import('./GetStartedTrialUsersPage').then((m) => ({
      default: m.GetStartedTrialUsersPage,
    })),
  ),
  [GetStartedVariant.Agentic]: lazy(
    () => import('./agentic-get-started/AgenticGetStartedPage'),
  ),
  [GetStartedVariant.Classic]: lazy(() => import('./GetStartedPage')),
};

const GetStartedEntryPoint = () => {
  const variant = useGetStartedVariant();
  const Page = variantToPage[variant];

  // Intercom default launcher should be shown only on "GetStarted" page
  useEffect(() => {
    if ((window as any).Intercom) {
      (window as any).Intercom('update', { hide_default_launcher: false });
    }
    return () => {
      if ((window as any).Intercom) {
        (window as any).Intercom('update', { hide_default_launcher: true });
      }
    };
  }, []);

  return (
    <Suspense fallback={<CenteredCircularProgress />}>
      <Page />
    </Suspense>
  );
};

export default GetStartedEntryPoint;
